module.exports = __webpack_public_path__ + "img/edge-5g-row.jpg";